<iframe [src]="privacyUrl" style="width: 100%;height:100%" height="100%" width="100%" frameborder="0"></iframe>
<button mat-mini-fab color="warn" style="position: absolute;top:8px;right:25px" (click)="close()">
    X<!-- <mat-icon>close</mat-icon> -->
</button>